import { Country } from '@axo/config/@types/Country.types';

// type Grades = {
//   [key in 'bad' | 'poor' | 'average' | 'great' | 'excellent']: string;
// };

type TrustPilotI18nProps = {
  [key in Lowercase<Country>]: {
    // grades: Grades;
    reviews: string;
    outOf: string;
    basedOn: string;
  };
};

export const i18n: TrustPilotI18nProps = {
  gb: {
    // grades: {
    //   bad: 'Bad',
    //   poor: 'Poor',
    //   average: 'Average',
    //   great: 'Great',
    //   excellent: 'Excellent',
    // },
    reviews: 'reviews',
    outOf: '/',
    basedOn: 'based on',
  },
  fi: {
    // grades: {
    //   bad: 'Huono',
    //   poor: 'Välttävä',
    //   average: 'Keskitasoinen',
    //   great: 'Hyvä',
    //   excellent: 'Erinomainen',
    // },
    reviews: 'arvosteluun',
    outOf: '/',
    basedOn: 'perustuu',
  },
  se: {
    // grades: {
    //   bad: 'Mycket dålig',
    //   poor: 'Dålig',
    //   average: 'Medel',
    //   great: 'Bra',
    //   excellent: 'Utmärkt',
    // },
    reviews: 'omdömen',
    outOf: 'av',
    basedOn: 'baserad på',
  },
  no: {
    // grades: {
    //   bad: 'Dårlig',
    //   poor: 'Under middels',
    //   average: 'Middels',
    //   great: 'Bra',
    //   excellent: 'enestående',
    // },
    reviews: 'anmeldelser',
    outOf: 'av',
    basedOn: 'basert på',
  },
  dk: {
    // grades: {
    //   bad: 'Dårlig',
    //   poor: 'Under middel',
    //   average: 'Middel',
    //   great: 'God',
    //   excellent: 'Fremragende',
    // },
    reviews: 'anmeldelser',
    outOf: 'ud af',
    basedOn: 'baseret på',
  },
};
